import { Form } from '@/components';
import { UpdateTaskGroupArgs } from '@/redux';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

interface BulkUpdateTaskModalProps {
  value: UpdateTaskGroupArgs;
  id: string;
  onSubmit: (value: UpdateTaskGroupArgs) => any;
  onClose: () => any;
}

const schema = Yup.object().shape({
  name: Yup.string().field().nullable().required(),
});

export function EditTaskGroupModal(props: BulkUpdateTaskModalProps) {
  const { onClose, onSubmit, value, id } = props;
  const { t } = useTranslation();

  const handleSubmit = (value: UpdateTaskGroupArgs) => {
    onSubmit({ name: value.name, id });
  };

  return (
    <Modal
      title={t('tasks.groups.editModalTitle')}
      visible
      onCancel={onClose}
      footer={[
        <Button key="back" type="default" onClick={onClose}>
          {t('cancel')}
        </Button>,
        <Form.Submit uid="update-task-group" key="submit" type="primary">
          {t('save')}
        </Form.Submit>,
      ]}
    >
      <Form.Formik<UpdateTaskGroupArgs>
        uid="update-task-group"
        i18n="tasks.groups"
        initialValues={value}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        <Form.Input name="name" />
      </Form.Formik>
    </Modal>
  );
}
